import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BatchesService } from './services';

@Component({
  selector: 'app-batches',
  templateUrl: './batches.component.html',
  styleUrls: ['./batches.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BatchesComponent implements OnInit {
  private readonly batchesService = inject(BatchesService);
  private readonly destroyRef = inject(DestroyRef);

  public ngOnInit(): void {
    this.batchesService
      .getLabelSizes()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }
}
